<div class="auth-page">
  <div class="auth-card auth-card-wide">
    <h1 class="auth-heading">Contact Proximity Administrators</h1>
    <p class="auth-subtitle">Enter your contact information below.</p>

    <form name="contactUsForm" #form="ngForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-3">
        <input pInputText id="company" placeholder="Your Company Name" type="text" [(ngModel)]="company" name="company"
          required [pAutoFocus]="true" class="w-full" />
        <div class="flex gap-3">
          <input pInputText id="firstname" placeholder="First Name" type="text" [(ngModel)]="firstname" class="w-1/2"
            name="firstname" required />
          <input pInputText id="lastname" placeholder="Last Name" type="text" [(ngModel)]="lastname" class="w-1/2"
            name="lastname" required />
        </div>
        <input pInputText id="email" placeholder="Email" type="email" [(ngModel)]="email" name="email" required
          class="w-full" />
        <input pInputText id="phone" placeholder="Mobile Cell #" type="tel" pattern="[0-9]{3}-?[0-9]{3}-?[0-9]{4}"
          [(ngModel)]="phone" name="phone" required class="w-full" />
        <textarea rows="3" pTextarea placeholder="Message" [(ngModel)]="message" name="message"
          class="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-primary"></textarea>

        <!-- Honeypot: hidden from humans (off-screen + tab-skipped + autocomplete off) but bots
             that auto-fill every field will populate it. Server silently drops any submission
             where this field is non-empty. -->
        <input type="text" name="website" [(ngModel)]="website" tabindex="-1" autocomplete="off"
          aria-hidden="true" style="position:absolute; left:-9999px; width:1px; height:1px; opacity:0;" />

        <div class="flex gap-2 mt-2">
          <button pButton pRipple type="button" label="Cancel" class="flex-auto p-button-outlined" routerLink="/"></button>
          <button pButton pRipple label="Submit" type="submit" class="flex-auto" [disabled]="form.invalid"
            [loading]="working"></button>
        </div>

        <p class="text-red-500 text-center mt-3 mb-0" *ngIf="error">{{error}}</p>
        <p class="text-green-500 text-center mt-3 mb-0" *ngIf="success">Thank you. You will be contacted shortly.</p>
      </div>
    </form>
  </div>
</div>
